import React, { useState, useEffect } from 'react';
import Link from '@material-ui/core/Link';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import PieChartComponent from 'components/PieChart';
import {
  getGoalsPieData,
  GOALS_TYPES,
  linkToGoalsSettings,
  emptyData
} from './goals.service';
import GoalsTooltip from './GoalsTooltip';
import { useHistory } from 'react-router-dom';
import useSettingsService from 'components/hooks/useSettingsService';
import WidgetDescription from '../../../performance/views/CustomReport/Widgets/CustomWidget/Header/WidgetDescription';
import { LBGoalsIcon } from '@linearb/buzz';

export const externalTooltipContent = item => {
  const {
    id,
    name,
    percent,
    setGoalText,
    setGoalLink,
    colorName,
    textColorName,
    prsMergedSum,
    didNotMeetSum,
    didNotMeetGoalTooltipDescription
  } = item || {};

  return (
    item && (
      <GoalsTooltip
        id={id}
        name={name}
        percent={percent}
        setGoalText={setGoalText}
        setGoalLink={setGoalLink}
        colorName={colorName}
        textColorName={textColorName}
        prsMergedSum={prsMergedSum}
        didNotMeetSum={didNotMeetSum}
        didNotMeetGoalTooltipDescription={didNotMeetGoalTooltipDescription}
      />
    )
  );
};

const Goals = ({ team, goals, teamDashboardWidgets }) => {
  const history = useHistory();
  const { getSettingOrDefinitionValue } = useSettingsService();

  const [goalsData, setGoalsData] = useState([]);
  const [isAllGoalsUnset, setIsAllGoalsUnset] = useState(false);

  useEffect(() => {
    if (teamDashboardWidgets !== null) {
      const { goalsPieData, isAllGoalsUnset } = getGoalsPieData({
        history,
        getSettingOrDefinitionValue,
        team,
        goals,
        teamDashboardWidgets
      });
      setIsAllGoalsUnset(isAllGoalsUnset);
      setGoalsData(goalsPieData);
    }
  }, [goals, teamDashboardWidgets]);

  return goalsData.length ? (
    <Flex items='end'>
      <Flex data-testid='goal-pie'>
        <PieChartComponent
          isGauge={true}
          data={goalsData}
          pieSize={{ width: 160, height: 160 }}
          pieLine={20}
          paddingAngle={5}
          showExternalTooltip={true}
          externalTooltipPosition='top'
          externalTooltipContent={externalTooltipContent}
          innerTextComponent={() => (
            <LBGoalsIcon className='size-6 text-slate-400' />
          )}
        />
      </Flex>
      <Flex
        direction='column'
        pl='x-medium'
        minWidth='10rem'
        data-testid='goal-text'
      >
        {isAllGoalsUnset ? (
          <Text size='medium'>
            <Link
              data-testid='set-up-goal-link'
              onClick={() => linkToGoalsSettings(history)}
            >
              Set up Team Goals
            </Link>
          </Text>
        ) : (
          <WidgetDescription
            formattedAverage={
              goalsData.filter(
                ({ order }) =>
                  order === GOALS_TYPES.MET_GOAL.order ||
                  order === GOALS_TYPES.ALMOST_MET_GOAL_PERCENT.order
              ).length
            }
            formattedDescription='Goals Reached'
          />
        )}
      </Flex>
    </Flex>
  ) : (
    <Flex items='end'>
      <Flex data-testid='goal-pie'>
        <PieChartComponent
          isGauge={true}
          data={emptyData}
          pieSize={{ width: 160, height: 160 }}
          pieLine={20}
          paddingAngle={5}
          showTooltip={false}
          innerTextComponent={() => (
            <Icon
              name='accuracy'
              size='large'
              color='shuttleGray'
              isThin={true}
            />
          )}
        />
      </Flex>
      <Flex
        direction='column'
        pl='x-medium'
        minWidth='10rem'
        data-testid='goal-text'
      >
        <Text size='medium' color='shuttleGray'>
          No data
        </Text>
      </Flex>
    </Flex>
  );
};

export default Goals;
